import { Pipe, PipeTransform } from '@angular/core';
import { DashboardCustomer } from '../../../api/models';


@Pipe({
  name: 'customerFilter'
})
export class CustomerFilterPipe implements PipeTransform {

  /**
   * Returns and array of one customer the signed in account is linked to, or if admin or no customer is linked then return all.
   */
  transform(customers: DashboardCustomer[], customerId: number): any {
    if (customerId > 0) {
      return [customers.find(customer => customer.id === customerId)]
    } else {
      return customers
    }
  }

}
